// Which schema a term comes from, as people read it (docs/ref-belonging-plan.md,
// step 5.6.5): "The Belonging Scale v2, Romaeuropa Festival". Every catalog
// entry is marked `from` the schema it was read from (lib/schema_turtle.js);
// the catalog lists each schema's header under `schemas`. A draft made from
// files has no header of its own (lib/schema_change.js, heldSchemas). Pure and
// small, for the browser as much as the server.

const derived = (catalog, id) => ['recordClasses', 'terms', 'valueSchemes']
  .some((key) => (catalog?.[key] ?? []).some((e) => e.from === id && e.derivedFrom));

// The schema a term (or record class, or value list) comes from: its header,
// or null for an id the catalog does not describe.
export function schemaOf(catalog, entryId, { publisher = '' } = {}) {
  const entry = ['terms', 'recordClasses', 'valueSchemes'].flatMap((key) => catalog?.[key] ?? []).find((e) => e.id === entryId);
  if (!entry?.from) return null;
  const header = (catalog.schemas ?? []).find((s) => s.id === entry.from);
  if (header) return header;
  return derived(catalog, entry.from) && !(catalog.publishes ?? []).includes(entry.from)
    ? { id: entry.from, title: `${publisher || entry.from}: draft schema`, publisher: publisher || null, version: 'draft' }
    : { id: entry.from };
}

// "The Belonging Scale v2, Romaeuropa Festival"; a bare number gets a "v". The
// publisher is left out when the title already starts with it, the version
// when it is a draft (the title says so).
export function schemaLabel(schema) {
  if (!schema) return null;
  const title = schema.title ?? schema.id;
  const version = !schema.version || schema.version === 'draft' ? ''
    : ` ${/^\d/.test(schema.version) ? `v${schema.version}` : schema.version}`;
  const publisher = schema.publisher && !title.startsWith(schema.publisher) ? `, ${schema.publisher}` : '';
  return `${title}${version}${publisher}`;
}

export const termSchemaLabel = (catalog, entryId, options) => schemaLabel(schemaOf(catalog, entryId, options));
